import * as Sentry from "@sentry/gatsby"

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.GATSBY_SENTRY_ENVIRONMENT,
  integrations: [],
})
